import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormCreateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormCreate = createAsyncThunk(
    'formCreate/fetchFormCreate',
    async ({ file, title, slug, description, content, formGroupId }) => {
        const response = await FormCreateService(file, title, slug, description, content, formGroupId)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const formCreateSlice = createSlice({
    name: 'formCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formCreateSlice.reducer;
